import React from 'react';
import { Space, Typography } from 'antd';
import { ClockCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const TimeEndedDisplay = () => {
  const { t } = useTranslation('common');
  const errorColor = '#ef4444'; // A shade of red

  return (
    <Space
      direction="vertical"
      align="center"
      size="middle"
    >
      <ClockCircleOutlined
        style={{
          fontSize: '48px',
          color: errorColor,
        }}
      />
      <Text
        style={{
          fontSize: '20px',
          color: errorColor,
          fontWeight: 500,
        }}
      >
        {t('header.section_time_ended')}
      </Text>
    </Space>
  );
};

export default TimeEndedDisplay;
